import type { Event } from '@patsnap/tahiti-core';
import type { EmbodimentHistoryState, EmbodimentItem } from '../types';

/**
 * 实施例历史记录服务
 * 用于管理实施例生成的历史记录，支持撤销和重做操作
 */
export const EmbodimentHistoryService = Symbol.for('EmbodimentHistoryService');

export interface EmbodimentHistoryService {
    /**
     * 状态变更事件
     * 当历史记录状态发生变化时触发
     */
    readonly onStateChange: Event<EmbodimentHistoryState>;

    /**
     * 历史记录切换事件
     * 当在历史记录间切换时触发
     */
    readonly onToggleHistory: Event<EmbodimentItem>;

    /**
     * 获取当前模型数据
     * @returns 历史记录状态
     */
    getModelData(): EmbodimentHistoryState;

    /**
     * 添加新的历史记录
     * @param embodiment - 实施例项
     */
    pushHistory(embodiment: EmbodimentItem): void;

    /**
     * 切换到下一个历史记录
     * @returns 切换后的实施例项
     */
    toggleNextHistory(): EmbodimentItem;

    /**
     * 切换到上一个历史记录
     * @returns 切换后的实施例项
     */
    togglePrevHistory(): EmbodimentItem;

    /**
     * 重置历史记录
     * 清空所有历史记录
     */
    resetHistory(): void;
}

